import React from 'react';

import './ThemeAttribution.css';

/**
 * Upphovsrättsnotiser för teman som bär tredjepartsmaterial.
 *
 * Det här är inte en artighet utan ett licensvillkor. Blizzards Legal FAQ ger
 * fans rätt att visa in-game-skärmdumpar icke-kommersiellt, men bara om
 * upphovsrätts- och varumärkesnotiser behålls. Ett tema som visar bilden utan
 * notisen uppfyller alltså inte villkoret.
 *
 * Listan är avsiktligt hårdkodad i stället för att bo i temamanifestet. Ett
 * saknat fält i ett manifest märks inte; en saknad post här syns direkt när
 * någon jämför med temalistan. Villkoret är dessutom kopplat till en enskild
 * bildkälla, inte till temat som datapost.
 *
 * Teman som INTE står här bär ingen tredjepartsbild: kartteman använder
 * skärmdumpar ur vår egen CS2-installation, och Mushroom Kingdom är en ren
 * palett utan bild.
 *
 * @returns {JSX.Element}
 */
export default function ThemeAttribution() {
  return (
    <div className="theme-attribution">
      <p>
        Ember använder en skärmdump ur Diablo® IV. Diablo och Blizzard
        Entertainment® är varumärken som tillhör Blizzard Entertainment, Inc.
        Bilden visas icke-kommersiellt enligt Blizzards riktlinjer för
        fan-innehåll. Temat är inte skapat, sponsrat eller godkänt av Blizzard.
      </p>
      <p>
        Surface använder en skärmdump ur ARC Raiders. ARC RAIDERS och EMBARK är
        varumärken som tillhör Embark Studios AB. Bilden visas
        icke-kommersiellt. Temat är inte skapat, sponsrat eller godkänt av
        Embark Studios.
      </p>
      <p>
        Fairway använder en skärmdump ur Golf With Your Friends. Golf With Your
        Friends och Team17 är varumärken som tillhör Team17 Digital Limited.
        Bilden visas icke-kommersiellt. Temat är inte skapat, sponsrat eller
        godkänt av Team17.
      </p>
      <p>
        Epic använder en skärmdump ur World of Warcraft®. World of Warcraft och
        Blizzard Entertainment® är varumärken som tillhör Blizzard
        Entertainment, Inc. Bilden visas icke-kommersiellt enligt Blizzards
        riktlinjer för fan-innehåll. Temat är inte skapat, sponsrat eller
        godkänt av Blizzard.
      </p>
      <p>
        Ringworld använder en skärmdump ur Halo Infinite. Halo och Xbox Game
        Studios är varumärken som tillhör Microsoft Corporation. Bilden visas
        icke-kommersiellt enligt Microsoft Game Content Usage Rules. Temat är
        inte skapat, sponsrat eller godkänt av Microsoft.
      </p>
      <p>
        Tibia använder en officiell skärmdump från tibia.com. Tibia är ett
        varumärke som tillhör CipSoft GmbH. Bilden visas icke-kommersiellt.
        Temat är inte skapat, sponsrat eller godkänt av CipSoft.
      </p>
      <p>
        Lemmings använder en skärmdump av Amigaversionen från 1991. Lemmings är
        ett varumärke som tillhör Sony Interactive Entertainment. Bilden visas
        icke-kommersiellt. Temat är inte skapat, sponsrat eller godkänt av
        rättighetsinnehavaren.
      </p>
      {/* Mushroom Kingdom står medvetet INTE här: dess bakgrund är egen
          genererad konst, inte en skärmdump. Se temats CSS-fil. */}
    </div>
  );
}
